import { createLayout, type Layout } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';

const rightSidebars = () => [];

export const globalLayout: Layout = createLayout({
	rightSidebars: rightSidebars(),
});
